import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {};
var AccessRightFilter = /* @__PURE__ */ ((AccessRightFilter2) => {
  AccessRightFilter2["ACTIVE"] = "ACTIVE";
  AccessRightFilter2["ADMIN_ROLE"] = "ADMIN_ROLE";
  AccessRightFilter2["DEACTIVATED"] = "DEACTIVATED";
  AccessRightFilter2["PENDING"] = "PENDING";
  AccessRightFilter2["USER_ROLE"] = "USER_ROLE";
  return AccessRightFilter2;
})(AccessRightFilter || {});
var AccessRightStatus = /* @__PURE__ */ ((AccessRightStatus2) => {
  AccessRightStatus2["ACTIVE"] = "ACTIVE";
  AccessRightStatus2["DEACTIVATED"] = "DEACTIVATED";
  AccessRightStatus2["PENDING"] = "PENDING";
  return AccessRightStatus2;
})(AccessRightStatus || {});
var AccountActivationStatus = /* @__PURE__ */ ((AccountActivationStatus2) => {
  AccountActivationStatus2["ACTIVE"] = "ACTIVE";
  AccountActivationStatus2["PENDING"] = "PENDING";
  return AccountActivationStatus2;
})(AccountActivationStatus || {});
var AdBudgetType = /* @__PURE__ */ ((AdBudgetType2) => {
  AdBudgetType2["BRANDED_ONWARDS"] = "BRANDED_ONWARDS";
  AdBudgetType2["CLASSIC_ONWARDS"] = "CLASSIC_ONWARDS";
  AdBudgetType2["PREMIUM_ONLY"] = "PREMIUM_ONLY";
  return AdBudgetType2;
})(AdBudgetType || {});
var AdRatingType = /* @__PURE__ */ ((AdRatingType2) => {
  AdRatingType2["HIGH"] = "HIGH";
  AdRatingType2["LOW"] = "LOW";
  AdRatingType2["NORMAL"] = "NORMAL";
  AdRatingType2["TOO_SOON_TO_RATE"] = "TOO_SOON_TO_RATE";
  AdRatingType2["UNABLE_TO_RATE"] = "UNABLE_TO_RATE";
  AdRatingType2["UNAVAILABLE"] = "UNAVAILABLE";
  return AdRatingType2;
})(AdRatingType || {});
var AdRepost = /* @__PURE__ */ ((AdRepost2) => {
  AdRepost2["NOT_REPOST"] = "NOT_REPOST";
  AdRepost2["REPOST"] = "REPOST";
  return AdRepost2;
})(AdRepost || {});
var AdTipsType = /* @__PURE__ */ ((AdTipsType2) => {
  AdTipsType2["ADD_QUESTIONS"] = "ADD_QUESTIONS";
  AdTipsType2["ADD_SPECIFIC_LOCATION"] = "ADD_SPECIFIC_LOCATION";
  AdTipsType2["INCREASE_SALARY"] = "INCREASE_SALARY";
  AdTipsType2["MAXIMISE_BRANDING"] = "MAXIMISE_BRANDING";
  AdTipsType2["NO_TIPS"] = "NO_TIPS";
  AdTipsType2["REVEAL_SALARY"] = "REVEAL_SALARY";
  AdTipsType2["REVIEW_AD_DETAILS"] = "REVIEW_AD_DETAILS";
  AdTipsType2["REVIEW_AD_SUMMARY"] = "REVIEW_AD_SUMMARY";
  return AdTipsType2;
})(AdTipsType || {});
var AdType = /* @__PURE__ */ ((AdType2) => {
  AdType2["BRANDED"] = "BRANDED";
  AdType2["BRANDED_UPGRADE"] = "BRANDED_UPGRADE";
  AdType2["CLASSIC"] = "CLASSIC";
  AdType2["CONCIERGE"] = "CONCIERGE";
  AdType2["GUARANTEED"] = "GUARANTEED";
  AdType2["PREMIUM"] = "PREMIUM";
  return AdType2;
})(AdType || {});
var AdTypeTheme = /* @__PURE__ */ ((AdTypeTheme2) => {
  AdTypeTheme2["BASIC"] = "BASIC";
  AdTypeTheme2["PRIMARY"] = "PRIMARY";
  return AdTypeTheme2;
})(AdTypeTheme || {});
var AdUsageAdStatus = /* @__PURE__ */ ((AdUsageAdStatus2) => {
  AdUsageAdStatus2["ACTIVE"] = "ACTIVE";
  AdUsageAdStatus2["EXPIRED"] = "EXPIRED";
  return AdUsageAdStatus2;
})(AdUsageAdStatus || {});
var AdvertiserStatus = /* @__PURE__ */ ((AdvertiserStatus2) => {
  AdvertiserStatus2["ACTIVE"] = "ACTIVE";
  AdvertiserStatus2["DEACTIVATED"] = "DEACTIVATED";
  AdvertiserStatus2["NEW"] = "NEW";
  AdvertiserStatus2["PENDING"] = "PENDING";
  AdvertiserStatus2["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
  return AdvertiserStatus2;
})(AdvertiserStatus || {});
var AnalyticsAdRatingConfidence = /* @__PURE__ */ ((AnalyticsAdRatingConfidence2) => {
  AnalyticsAdRatingConfidence2["HIGH"] = "HIGH";
  AnalyticsAdRatingConfidence2["LOW"] = "LOW";
  return AnalyticsAdRatingConfidence2;
})(AnalyticsAdRatingConfidence || {});
var AnalyticsAdRatingScore = /* @__PURE__ */ ((AnalyticsAdRatingScore2) => {
  AnalyticsAdRatingScore2["HIGH"] = "HIGH";
  AnalyticsAdRatingScore2["LOW"] = "LOW";
  AnalyticsAdRatingScore2["NORMAL"] = "NORMAL";
  return AnalyticsAdRatingScore2;
})(AnalyticsAdRatingScore || {});
var AnalyticsAdRatingStatus = /* @__PURE__ */ ((AnalyticsAdRatingStatus2) => {
  AnalyticsAdRatingStatus2["ARCHIVED"] = "ARCHIVED";
  AnalyticsAdRatingStatus2["AVAILABLE_CANNOT_RATE"] = "AVAILABLE_CANNOT_RATE";
  AnalyticsAdRatingStatus2["AVAILABLE_PENDING_RATING"] = "AVAILABLE_PENDING_RATING";
  AnalyticsAdRatingStatus2["AVAILABLE_WITH_RATING"] = "AVAILABLE_WITH_RATING";
  AnalyticsAdRatingStatus2["ERRORED"] = "ERRORED";
  AnalyticsAdRatingStatus2["NOT_APPLICABLE"] = "NOT_APPLICABLE";
  AnalyticsAdRatingStatus2["NOT_INCLUDED"] = "NOT_INCLUDED";
  AnalyticsAdRatingStatus2["PENDING"] = "PENDING";
  AnalyticsAdRatingStatus2["UNAVAILABLE"] = "UNAVAILABLE";
  AnalyticsAdRatingStatus2["WITHHELD"] = "WITHHELD";
  return AnalyticsAdRatingStatus2;
})(AnalyticsAdRatingStatus || {});
var AnalyticsAdType = /* @__PURE__ */ ((AnalyticsAdType2) => {
  AnalyticsAdType2["AUTO_INCLUDE"] = "AUTO_INCLUDE";
  AnalyticsAdType2["BASIC"] = "BASIC";
  AnalyticsAdType2["BRANDED"] = "BRANDED";
  AnalyticsAdType2["CLASSIC"] = "CLASSIC";
  AnalyticsAdType2["PREMIUM"] = "PREMIUM";
  AnalyticsAdType2["STANDOUT"] = "STANDOUT";
  return AnalyticsAdType2;
})(AnalyticsAdType || {});
var AnalyticsBenchmarkScenario = /* @__PURE__ */ ((AnalyticsBenchmarkScenario2) => {
  AnalyticsBenchmarkScenario2["COUNTRY"] = "COUNTRY";
  AnalyticsBenchmarkScenario2["EXACT"] = "EXACT";
  AnalyticsBenchmarkScenario2["EXACT_COUNTRY"] = "EXACT_COUNTRY";
  AnalyticsBenchmarkScenario2["EXACT_REGIONAL"] = "EXACT_REGIONAL";
  AnalyticsBenchmarkScenario2["IDEAL"] = "IDEAL";
  AnalyticsBenchmarkScenario2["IDEAL_COUNTRY"] = "IDEAL_COUNTRY";
  AnalyticsBenchmarkScenario2["IDEAL_REGIONAL"] = "IDEAL_REGIONAL";
  AnalyticsBenchmarkScenario2["SUBCLASS_COUNTRY"] = "SUBCLASS_COUNTRY";
  AnalyticsBenchmarkScenario2["SUBCLASS_LOCATION"] = "SUBCLASS_LOCATION";
  AnalyticsBenchmarkScenario2["SUBCLASS_REGIONAL"] = "SUBCLASS_REGIONAL";
  return AnalyticsBenchmarkScenario2;
})(AnalyticsBenchmarkScenario || {});
var AnalyticsInsightsRoleAdPerformanceCode = /* @__PURE__ */ ((AnalyticsInsightsRoleAdPerformanceCode2) => {
  AnalyticsInsightsRoleAdPerformanceCode2["INSUFFICIENT_COMPANIES"] = "INSUFFICIENT_COMPANIES";
  AnalyticsInsightsRoleAdPerformanceCode2["INSUFFICIENT_EXPIRED_ADS"] = "INSUFFICIENT_EXPIRED_ADS";
  AnalyticsInsightsRoleAdPerformanceCode2["SUFFICIENT_DATA"] = "SUFFICIENT_DATA";
  return AnalyticsInsightsRoleAdPerformanceCode2;
})(AnalyticsInsightsRoleAdPerformanceCode || {});
var AnalyticsInsightsRoleAdPerformanceRecommendationType = /* @__PURE__ */ ((AnalyticsInsightsRoleAdPerformanceRecommendationType2) => {
  AnalyticsInsightsRoleAdPerformanceRecommendationType2["MOST_COMPANIES_POSTED_PREMIUM"] = "MOST_COMPANIES_POSTED_PREMIUM";
  AnalyticsInsightsRoleAdPerformanceRecommendationType2["PREMIUM_ATTRACTED_X_PER_AD"] = "PREMIUM_ATTRACTED_X_PER_AD";
  AnalyticsInsightsRoleAdPerformanceRecommendationType2["PREMIUM_ATTRACTED_X_TIMES"] = "PREMIUM_ATTRACTED_X_TIMES";
  AnalyticsInsightsRoleAdPerformanceRecommendationType2["PREMIUM_DELIVER_MORE_AT_START"] = "PREMIUM_DELIVER_MORE_AT_START";
  return AnalyticsInsightsRoleAdPerformanceRecommendationType2;
})(AnalyticsInsightsRoleAdPerformanceRecommendationType || {});
var AnalyticsInsightsRoleCompetitionForTalentCode = /* @__PURE__ */ ((AnalyticsInsightsRoleCompetitionForTalentCode2) => {
  AnalyticsInsightsRoleCompetitionForTalentCode2["INSUFFICIENT_ADS_POSTED"] = "INSUFFICIENT_ADS_POSTED";
  AnalyticsInsightsRoleCompetitionForTalentCode2["INSUFFICIENT_COMPANIES"] = "INSUFFICIENT_COMPANIES";
  AnalyticsInsightsRoleCompetitionForTalentCode2["SUFFICIENT_DATA"] = "SUFFICIENT_DATA";
  return AnalyticsInsightsRoleCompetitionForTalentCode2;
})(AnalyticsInsightsRoleCompetitionForTalentCode || {});
var AnalyticsInsightsRoleCompetitionForTalentConfidence = /* @__PURE__ */ ((AnalyticsInsightsRoleCompetitionForTalentConfidence2) => {
  AnalyticsInsightsRoleCompetitionForTalentConfidence2["HIGH"] = "HIGH";
  AnalyticsInsightsRoleCompetitionForTalentConfidence2["LOW"] = "LOW";
  return AnalyticsInsightsRoleCompetitionForTalentConfidence2;
})(AnalyticsInsightsRoleCompetitionForTalentConfidence || {});
var AnalyticsInsightsRoleUniqueApplicantsCode = /* @__PURE__ */ ((AnalyticsInsightsRoleUniqueApplicantsCode2) => {
  AnalyticsInsightsRoleUniqueApplicantsCode2["INSUFFICIENT_COMPANIES"] = "INSUFFICIENT_COMPANIES";
  AnalyticsInsightsRoleUniqueApplicantsCode2["SUFFICIENT_DATA"] = "SUFFICIENT_DATA";
  return AnalyticsInsightsRoleUniqueApplicantsCode2;
})(AnalyticsInsightsRoleUniqueApplicantsCode || {});
var AnalyticsPostTypeCategory = /* @__PURE__ */ ((AnalyticsPostTypeCategory2) => {
  AnalyticsPostTypeCategory2["DIRECT"] = "DIRECT";
  AnalyticsPostTypeCategory2["INDIRECT"] = "INDIRECT";
  return AnalyticsPostTypeCategory2;
})(AnalyticsPostTypeCategory || {});
var AnalyticsSalaryType = /* @__PURE__ */ ((AnalyticsSalaryType2) => {
  AnalyticsSalaryType2["ANNUAL_COMMISSION"] = "ANNUAL_COMMISSION";
  AnalyticsSalaryType2["ANNUAL_PACKAGE"] = "ANNUAL_PACKAGE";
  AnalyticsSalaryType2["COMMISSION_ONLY"] = "COMMISSION_ONLY";
  AnalyticsSalaryType2["HOURLY"] = "HOURLY";
  AnalyticsSalaryType2["MONTHLY"] = "MONTHLY";
  return AnalyticsSalaryType2;
})(AnalyticsSalaryType || {});
var AnalyticsTalentSearchUsageTrendsByTimeInterval = /* @__PURE__ */ ((AnalyticsTalentSearchUsageTrendsByTimeInterval2) => {
  AnalyticsTalentSearchUsageTrendsByTimeInterval2["DAILY"] = "DAILY";
  AnalyticsTalentSearchUsageTrendsByTimeInterval2["MONTHLY"] = "MONTHLY";
  return AnalyticsTalentSearchUsageTrendsByTimeInterval2;
})(AnalyticsTalentSearchUsageTrendsByTimeInterval || {});
var AnalyticsWorkType = /* @__PURE__ */ ((AnalyticsWorkType2) => {
  AnalyticsWorkType2["CASUAL"] = "CASUAL";
  AnalyticsWorkType2["CONTRACT"] = "CONTRACT";
  AnalyticsWorkType2["FULL_TIME"] = "FULL_TIME";
  AnalyticsWorkType2["PART_TIME"] = "PART_TIME";
  return AnalyticsWorkType2;
})(AnalyticsWorkType || {});
var ApplicationAttachmentType = /* @__PURE__ */ ((ApplicationAttachmentType2) => {
  ApplicationAttachmentType2["COVER_LETTER"] = "COVER_LETTER";
  ApplicationAttachmentType2["OTHER"] = "OTHER";
  ApplicationAttachmentType2["RESUME"] = "RESUME";
  ApplicationAttachmentType2["SELECTION_CRITERIA"] = "SELECTION_CRITERIA";
  return ApplicationAttachmentType2;
})(ApplicationAttachmentType || {});
var ApplicationBucket = /* @__PURE__ */ ((ApplicationBucket2) => {
  ApplicationBucket2["ACCEPT"] = "ACCEPT";
  ApplicationBucket2["INBOX"] = "INBOX";
  ApplicationBucket2["INTERVIEW"] = "INTERVIEW";
  ApplicationBucket2["NOT_SUITABLE"] = "NOT_SUITABLE";
  ApplicationBucket2["OFFER"] = "OFFER";
  ApplicationBucket2["PRESCREEN"] = "PRESCREEN";
  ApplicationBucket2["SHORTLIST"] = "SHORTLIST";
  return ApplicationBucket2;
})(ApplicationBucket || {});
var ApplicationQuestionnaireQuestionSource = /* @__PURE__ */ ((ApplicationQuestionnaireQuestionSource2) => {
  ApplicationQuestionnaireQuestionSource2["Custom"] = "Custom";
  ApplicationQuestionnaireQuestionSource2["Library"] = "Library";
  return ApplicationQuestionnaireQuestionSource2;
})(ApplicationQuestionnaireQuestionSource || {});
var ApplicationQuestionnaireQuestionStatus = /* @__PURE__ */ ((ApplicationQuestionnaireQuestionStatus2) => {
  ApplicationQuestionnaireQuestionStatus2["CANNOT_MATCH"] = "CANNOT_MATCH";
  ApplicationQuestionnaireQuestionStatus2["MATCH"] = "MATCH";
  ApplicationQuestionnaireQuestionStatus2["NO_MATCH"] = "NO_MATCH";
  ApplicationQuestionnaireQuestionStatus2["PARTIAL_MATCH"] = "PARTIAL_MATCH";
  return ApplicationQuestionnaireQuestionStatus2;
})(ApplicationQuestionnaireQuestionStatus || {});
var ApplicationSort = /* @__PURE__ */ ((ApplicationSort2) => {
  ApplicationSort2["APPLICATION_DATE"] = "APPLICATION_DATE";
  ApplicationSort2["NAME"] = "NAME";
  ApplicationSort2["RATING"] = "RATING";
  ApplicationSort2["RELEVANCE"] = "RELEVANCE";
  ApplicationSort2["SCORE"] = "SCORE";
  ApplicationSort2["SEARCH_RELEVANCE"] = "SEARCH_RELEVANCE";
  return ApplicationSort2;
})(ApplicationSort || {});
var ApplicationSource = /* @__PURE__ */ ((ApplicationSource2) => {
  ApplicationSource2["NATIVE"] = "NATIVE";
  ApplicationSource2["UPLOADED"] = "UPLOADED";
  return ApplicationSource2;
})(ApplicationSource || {});
var ApplicationStatusFolder = /* @__PURE__ */ ((ApplicationStatusFolder2) => {
  ApplicationStatusFolder2["ACCEPT"] = "ACCEPT";
  ApplicationStatusFolder2["INBOX"] = "INBOX";
  ApplicationStatusFolder2["INTERVIEW"] = "INTERVIEW";
  ApplicationStatusFolder2["NOT_SUITABLE"] = "NOT_SUITABLE";
  ApplicationStatusFolder2["OFFER"] = "OFFER";
  ApplicationStatusFolder2["PRESCREEN"] = "PRESCREEN";
  ApplicationStatusFolder2["SHORTLIST"] = "SHORTLIST";
  return ApplicationStatusFolder2;
})(ApplicationStatusFolder || {});
var Bank2C2P = /* @__PURE__ */ ((Bank2C2P2) => {
  Bank2C2P2["bay"] = "bay";
  Bank2C2P2["bbl"] = "bbl";
  Bank2C2P2["bca"] = "bca";
  Bank2C2P2["bni"] = "bni";
  Bank2C2P2["bpi"] = "bpi";
  Bank2C2P2["bri"] = "bri";
  Bank2C2P2["cimb"] = "cimb";
  Bank2C2P2["kbank"] = "kbank";
  Bank2C2P2["ktb"] = "ktb";
  Bank2C2P2["mandiri"] = "mandiri";
  Bank2C2P2["scb"] = "scb";
  Bank2C2P2["tmb"] = "tmb";
  Bank2C2P2["unionbank"] = "unionbank";
  Bank2C2P2["uob"] = "uob";
  return Bank2C2P2;
})(Bank2C2P || {});
var BillableStatus = /* @__PURE__ */ ((BillableStatus2) => {
  BillableStatus2["BILLABLE"] = "BILLABLE";
  BillableStatus2["NOT_BILLABLE"] = "NOT_BILLABLE";
  return BillableStatus2;
})(BillableStatus || {});
var BillingStatus = /* @__PURE__ */ ((BillingStatus2) => {
  BillingStatus2["OK"] = "OK";
  BillingStatus2["ON_CREDIT_HOLD"] = "ON_CREDIT_HOLD";
  return BillingStatus2;
})(BillingStatus || {});
var BrandAssetTypeEnum = /* @__PURE__ */ ((BrandAssetTypeEnum2) => {
  BrandAssetTypeEnum2["cover"] = "cover";
  BrandAssetTypeEnum2["logo"] = "logo";
  return BrandAssetTypeEnum2;
})(BrandAssetTypeEnum || {});
var BrandOwnerType = /* @__PURE__ */ ((BrandOwnerType2) => {
  BrandOwnerType2["advertiserId"] = "advertiserId";
  BrandOwnerType2["seekId"] = "seekId";
  return BrandOwnerType2;
})(BrandOwnerType || {});
var BrandState = /* @__PURE__ */ ((BrandState2) => {
  BrandState2["ACTIVE"] = "ACTIVE";
  BrandState2["DELETED"] = "DELETED";
  BrandState2["INACTIVE"] = "INACTIVE";
  return BrandState2;
})(BrandState || {});
var CacheControlScope = /* @__PURE__ */ ((CacheControlScope2) => {
  CacheControlScope2["PRIVATE"] = "PRIVATE";
  CacheControlScope2["PUBLIC"] = "PUBLIC";
  return CacheControlScope2;
})(CacheControlScope || {});
var CandidateAnswerType = /* @__PURE__ */ ((CandidateAnswerType2) => {
  CandidateAnswerType2["FreeText"] = "FreeText";
  CandidateAnswerType2["SingleSelect"] = "SingleSelect";
  return CandidateAnswerType2;
})(CandidateAnswerType || {});
var CandidateLabel = /* @__PURE__ */ ((CandidateLabel2) => {
  CandidateLabel2["APPLICATION_STARTS"] = "APPLICATION_STARTS";
  CandidateLabel2["CANDIDATES"] = "CANDIDATES";
  return CandidateLabel2;
})(CandidateLabel || {});
var CartItemProductTypeInput = /* @__PURE__ */ ((CartItemProductTypeInput2) => {
  CartItemProductTypeInput2["AD_BUDGET"] = "AD_BUDGET";
  CartItemProductTypeInput2["AD_PRODUCT"] = "AD_PRODUCT";
  CartItemProductTypeInput2["AD_PRODUCT_ADD_ON"] = "AD_PRODUCT_ADD_ON";
  CartItemProductTypeInput2["AD_PRODUCT_UPGRADE"] = "AD_PRODUCT_UPGRADE";
  return CartItemProductTypeInput2;
})(CartItemProductTypeInput || {});
var CatalogueProductPurchaseState = /* @__PURE__ */ ((CatalogueProductPurchaseState2) => {
  CatalogueProductPurchaseState2["PURCHASABLE"] = "PURCHASABLE";
  CatalogueProductPurchaseState2["PURCHASED"] = "PURCHASED";
  return CatalogueProductPurchaseState2;
})(CatalogueProductPurchaseState || {});
var ChannelCode = /* @__PURE__ */ ((ChannelCode2) => {
  ChannelCode2["ALIPAYHK"] = "ALIPAYHK";
  ChannelCode2["BILLEASE"] = "BILLEASE";
  ChannelCode2["DANA"] = "DANA";
  ChannelCode2["GCASH"] = "GCASH";
  ChannelCode2["GRAB"] = "GRAB";
  ChannelCode2["HKFPSQR"] = "HKFPSQR";
  ChannelCode2["HOMECREDIT"] = "HOMECREDIT";
  ChannelCode2["LINKAJA"] = "LINKAJA";
  ChannelCode2["OVO"] = "OVO";
  ChannelCode2["PAYMAYA"] = "PAYMAYA";
  ChannelCode2["PAYPAL"] = "PAYPAL";
  ChannelCode2["SHPQR"] = "SHPQR";
  return ChannelCode2;
})(ChannelCode || {});
var CompanyProfileActionType = /* @__PURE__ */ ((CompanyProfileActionType2) => {
  CompanyProfileActionType2["CLAIM"] = "CLAIM";
  CompanyProfileActionType2["MANAGE"] = "MANAGE";
  return CompanyProfileActionType2;
})(CompanyProfileActionType || {});
var ContractType = /* @__PURE__ */ ((ContractType2) => {
  ContractType2["AD_PACK"] = "AD_PACK";
  ContractType2["MASTER_AGREEMENT"] = "MASTER_AGREEMENT";
  ContractType2["PRICING_GROUP"] = "PRICING_GROUP";
  ContractType2["SEEK_CONTRACT"] = "SEEK_CONTRACT";
  ContractType2["SUBSCRIPTION"] = "SUBSCRIPTION";
  ContractType2["TALENT_SEARCH_CONTRACT"] = "TALENT_SEARCH_CONTRACT";
  return ContractType2;
})(ContractType || {});
var CreditCardBrandInput = /* @__PURE__ */ ((CreditCardBrandInput2) => {
  CreditCardBrandInput2["AMEX"] = "AMEX";
  CreditCardBrandInput2["MASTER_CARD"] = "MASTER_CARD";
  CreditCardBrandInput2["VISA"] = "VISA";
  return CreditCardBrandInput2;
})(CreditCardBrandInput || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["AUD"] = "AUD";
  Currency2["HKD"] = "HKD";
  Currency2["IDR"] = "IDR";
  Currency2["MYR"] = "MYR";
  Currency2["NZD"] = "NZD";
  Currency2["PHP"] = "PHP";
  Currency2["SGD"] = "SGD";
  Currency2["THB"] = "THB";
  return Currency2;
})(Currency || {});
var DisplayRecommendation = /* @__PURE__ */ ((DisplayRecommendation2) => {
  DisplayRecommendation2["exclusive"] = "exclusive";
  DisplayRecommendation2["inclusive"] = "inclusive";
  return DisplayRecommendation2;
})(DisplayRecommendation || {});
var DraftJobFlowType = /* @__PURE__ */ ((DraftJobFlowType2) => {
  DraftJobFlowType2["CREATE"] = "CREATE";
  DraftJobFlowType2["EDIT"] = "EDIT";
  DraftJobFlowType2["MULTILOCATION"] = "MULTILOCATION";
  return DraftJobFlowType2;
})(DraftJobFlowType || {});
var DraftJobPaymentOption = /* @__PURE__ */ ((DraftJobPaymentOption2) => {
  DraftJobPaymentOption2["CONTRACT"] = "CONTRACT";
  DraftJobPaymentOption2["CREDIT_CARD"] = "CREDIT_CARD";
  DraftJobPaymentOption2["INVOICE"] = "INVOICE";
  DraftJobPaymentOption2["SAVED_CREDIT_CARD"] = "SAVED_CREDIT_CARD";
  return DraftJobPaymentOption2;
})(DraftJobPaymentOption || {});
var DraftJobProgress = /* @__PURE__ */ ((DraftJobProgress2) => {
  DraftJobProgress2["CLASSIFY"] = "CLASSIFY";
  DraftJobProgress2["MANAGE"] = "MANAGE";
  DraftJobProgress2["PAY_AND_POST"] = "PAY_AND_POST";
  DraftJobProgress2["SELECT_AD_TYPE"] = "SELECT_AD_TYPE";
  DraftJobProgress2["WRITE"] = "WRITE";
  return DraftJobProgress2;
})(DraftJobProgress || {});
var DraftJobSalaryCurrency = /* @__PURE__ */ ((DraftJobSalaryCurrency2) => {
  DraftJobSalaryCurrency2["AUD"] = "AUD";
  DraftJobSalaryCurrency2["BDT"] = "BDT";
  DraftJobSalaryCurrency2["CNY"] = "CNY";
  DraftJobSalaryCurrency2["EUR"] = "EUR";
  DraftJobSalaryCurrency2["GBP"] = "GBP";
  DraftJobSalaryCurrency2["HKD"] = "HKD";
  DraftJobSalaryCurrency2["IDR"] = "IDR";
  DraftJobSalaryCurrency2["INR"] = "INR";
  DraftJobSalaryCurrency2["JPY"] = "JPY";
  DraftJobSalaryCurrency2["MYR"] = "MYR";
  DraftJobSalaryCurrency2["NZD"] = "NZD";
  DraftJobSalaryCurrency2["PHP"] = "PHP";
  DraftJobSalaryCurrency2["SGD"] = "SGD";
  DraftJobSalaryCurrency2["THB"] = "THB";
  DraftJobSalaryCurrency2["USD"] = "USD";
  DraftJobSalaryCurrency2["VND"] = "VND";
  return DraftJobSalaryCurrency2;
})(DraftJobSalaryCurrency || {});
var DraftJobWritingMode = /* @__PURE__ */ ((DraftJobWritingMode2) => {
  DraftJobWritingMode2["GUIDED"] = "GUIDED";
  DraftJobWritingMode2["STANDARD"] = "STANDARD";
  return DraftJobWritingMode2;
})(DraftJobWritingMode || {});
var DraftStatus = /* @__PURE__ */ ((DraftStatus2) => {
  DraftStatus2["CLOSED"] = "CLOSED";
  DraftStatus2["DELETED"] = "DELETED";
  DraftStatus2["OPEN"] = "OPEN";
  DraftStatus2["PENDING"] = "PENDING";
  return DraftStatus2;
})(DraftStatus || {});
var DrawdownType = /* @__PURE__ */ ((DrawdownType2) => {
  DrawdownType2["BALANCE"] = "BALANCE";
  DrawdownType2["PACK"] = "PACK";
  DrawdownType2["PAYABLE"] = "PAYABLE";
  return DrawdownType2;
})(DrawdownType || {});
var DurationUnit = /* @__PURE__ */ ((DurationUnit2) => {
  DurationUnit2["DAY"] = "DAY";
  DurationUnit2["HOUR"] = "HOUR";
  DurationUnit2["MINUTE"] = "MINUTE";
  DurationUnit2["MONTH"] = "MONTH";
  DurationUnit2["SECOND"] = "SECOND";
  DurationUnit2["WEEK"] = "WEEK";
  DurationUnit2["YEAR"] = "YEAR";
  return DurationUnit2;
})(DurationUnit || {});
var ExpireReason = /* @__PURE__ */ ((ExpireReason2) => {
  ExpireReason2["FRAUDULENT"] = "FRAUDULENT";
  ExpireReason2["MANUAL"] = "MANUAL";
  ExpireReason2["NATURAL"] = "NATURAL";
  ExpireReason2["NONCOMPLIANT"] = "NONCOMPLIANT";
  return ExpireReason2;
})(ExpireReason || {});
var FiltersAdRatingType = /* @__PURE__ */ ((FiltersAdRatingType2) => {
  FiltersAdRatingType2["HIGH"] = "HIGH";
  FiltersAdRatingType2["LOW"] = "LOW";
  FiltersAdRatingType2["NORMAL"] = "NORMAL";
  FiltersAdRatingType2["NO_RATING"] = "NO_RATING";
  return FiltersAdRatingType2;
})(FiltersAdRatingType || {});
var Frequency = /* @__PURE__ */ ((Frequency2) => {
  Frequency2["DAILY"] = "DAILY";
  Frequency2["EVERY_APPLICATION"] = "EVERY_APPLICATION";
  Frequency2["NEVER"] = "NEVER";
  Frequency2["WEEKLY"] = "WEEKLY";
  return Frequency2;
})(Frequency || {});
var GuidedDetailsType = /* @__PURE__ */ ((GuidedDetailsType2) => {
  GuidedDetailsType2["ABOUT_BUSINESS"] = "ABOUT_BUSINESS";
  GuidedDetailsType2["BENEFITS"] = "BENEFITS";
  GuidedDetailsType2["QUALIFICATIONS"] = "QUALIFICATIONS";
  GuidedDetailsType2["RESPONSIBILITIES"] = "RESPONSIBILITIES";
  return GuidedDetailsType2;
})(GuidedDetailsType || {});
var HirerAccountStatus = /* @__PURE__ */ ((HirerAccountStatus2) => {
  HirerAccountStatus2["ACTIVE"] = "ACTIVE";
  HirerAccountStatus2["DEACTIVATED"] = "DEACTIVATED";
  HirerAccountStatus2["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
  return HirerAccountStatus2;
})(HirerAccountStatus || {});
var HirerActivityType = /* @__PURE__ */ ((HirerActivityType2) => {
  HirerActivityType2["NOTE_ADDED"] = "NOTE_ADDED";
  HirerActivityType2["NOTE_DELETED"] = "NOTE_DELETED";
  return HirerActivityType2;
})(HirerActivityType || {});
var HirerGroup = /* @__PURE__ */ ((HirerGroup2) => {
  HirerGroup2["ADVERTISER"] = "ADVERTISER";
  HirerGroup2["AGENT"] = "AGENT";
  HirerGroup2["RECRUITMENT_SOFTWARE_PROVIDER"] = "RECRUITMENT_SOFTWARE_PROVIDER";
  return HirerGroup2;
})(HirerGroup || {});
var HirerQuestionType = /* @__PURE__ */ ((HirerQuestionType2) => {
  HirerQuestionType2["FreeText"] = "FreeText";
  HirerQuestionType2["SingleSelect"] = "SingleSelect";
  return HirerQuestionType2;
})(HirerQuestionType || {});
var HirerType = /* @__PURE__ */ ((HirerType2) => {
  HirerType2["BPO"] = "BPO";
  HirerType2["CORPORATE"] = "CORPORATE";
  HirerType2["GOVERNMENT"] = "GOVERNMENT";
  HirerType2["JORA_LOCAL"] = "JORA_LOCAL";
  HirerType2["RECRUITER"] = "RECRUITER";
  HirerType2["SME"] = "SME";
  HirerType2["SUBSCRIPTION_PARTNER"] = "SUBSCRIPTION_PARTNER";
  return HirerType2;
})(HirerType || {});
var HirerUserStatus = /* @__PURE__ */ ((HirerUserStatus2) => {
  HirerUserStatus2["ACTIVE"] = "ACTIVE";
  HirerUserStatus2["DEACTIVATED"] = "DEACTIVATED";
  HirerUserStatus2["PENDING"] = "PENDING";
  HirerUserStatus2["UNVERIFIED"] = "UNVERIFIED";
  return HirerUserStatus2;
})(HirerUserStatus || {});
var IntegrationPartnerTier = /* @__PURE__ */ ((IntegrationPartnerTier2) => {
  IntegrationPartnerTier2["CONNECTED_MIDDLEWARE"] = "CONNECTED_MIDDLEWARE";
  IntegrationPartnerTier2["CONNECTED_PARTNERS"] = "CONNECTED_PARTNERS";
  IntegrationPartnerTier2["GOLD_PARTNERS"] = "GOLD_PARTNERS";
  IntegrationPartnerTier2["KEY_MIDDLEWARE_PARTNERS"] = "KEY_MIDDLEWARE_PARTNERS";
  IntegrationPartnerTier2["PLATINUM_PARTNERS"] = "PLATINUM_PARTNERS";
  IntegrationPartnerTier2["SILVER_PARTNERS"] = "SILVER_PARTNERS";
  return IntegrationPartnerTier2;
})(IntegrationPartnerTier || {});
var IntegrationRelationshipTypeEnum = /* @__PURE__ */ ((IntegrationRelationshipTypeEnum2) => {
  IntegrationRelationshipTypeEnum2["APPLICATION_EXPORT"] = "APPLICATION_EXPORT";
  IntegrationRelationshipTypeEnum2["APPLICATION_PREFILL"] = "APPLICATION_PREFILL";
  IntegrationRelationshipTypeEnum2["JOB_POSTING"] = "JOB_POSTING";
  IntegrationRelationshipTypeEnum2["PROACTIVE_SOURCING"] = "PROACTIVE_SOURCING";
  return IntegrationRelationshipTypeEnum2;
})(IntegrationRelationshipTypeEnum || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["due"] = "due";
  InvoiceStatus2["paid"] = "paid";
  InvoiceStatus2["pending"] = "pending";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var JobAdBookingCountryCode = /* @__PURE__ */ ((JobAdBookingCountryCode2) => {
  JobAdBookingCountryCode2["AU"] = "AU";
  JobAdBookingCountryCode2["HK"] = "HK";
  JobAdBookingCountryCode2["ID"] = "ID";
  JobAdBookingCountryCode2["MY"] = "MY";
  JobAdBookingCountryCode2["NZ"] = "NZ";
  JobAdBookingCountryCode2["PH"] = "PH";
  JobAdBookingCountryCode2["SG"] = "SG";
  JobAdBookingCountryCode2["TH"] = "TH";
  return JobAdBookingCountryCode2;
})(JobAdBookingCountryCode || {});
var JobAdType = /* @__PURE__ */ ((JobAdType2) => {
  JobAdType2["BRANDED"] = "BRANDED";
  JobAdType2["BRANDED_UPGRADE"] = "BRANDED_UPGRADE";
  JobAdType2["CLASSIC"] = "CLASSIC";
  JobAdType2["CONCIERGE"] = "CONCIERGE";
  JobAdType2["GUARANTEED"] = "GUARANTEED";
  JobAdType2["PREMIUM"] = "PREMIUM";
  return JobAdType2;
})(JobAdType || {});
var JobPlacementPostType = /* @__PURE__ */ ((JobPlacementPostType2) => {
  JobPlacementPostType2["AdPostingApi"] = "AdPostingApi";
  JobPlacementPostType2["Direct"] = "Direct";
  return JobPlacementPostType2;
})(JobPlacementPostType || {});
var JobSalaryCurrency = /* @__PURE__ */ ((JobSalaryCurrency2) => {
  JobSalaryCurrency2["AUD"] = "AUD";
  JobSalaryCurrency2["BDT"] = "BDT";
  JobSalaryCurrency2["CNY"] = "CNY";
  JobSalaryCurrency2["EUR"] = "EUR";
  JobSalaryCurrency2["GBP"] = "GBP";
  JobSalaryCurrency2["HKD"] = "HKD";
  JobSalaryCurrency2["IDR"] = "IDR";
  JobSalaryCurrency2["INR"] = "INR";
  JobSalaryCurrency2["JPY"] = "JPY";
  JobSalaryCurrency2["MYR"] = "MYR";
  JobSalaryCurrency2["NZD"] = "NZD";
  JobSalaryCurrency2["PHP"] = "PHP";
  JobSalaryCurrency2["SGD"] = "SGD";
  JobSalaryCurrency2["THB"] = "THB";
  JobSalaryCurrency2["USD"] = "USD";
  JobSalaryCurrency2["VND"] = "VND";
  return JobSalaryCurrency2;
})(JobSalaryCurrency || {});
var JobSource = /* @__PURE__ */ ((JobSource2) => {
  JobSource2["DIRECT_LISTING"] = "DIRECT_LISTING";
  JobSource2["DRAFT"] = "DRAFT";
  JobSource2["INDIRECT_LISTING"] = "INDIRECT_LISTING";
  return JobSource2;
})(JobSource || {});
var JobStatus = /* @__PURE__ */ ((JobStatus2) => {
  JobStatus2["ACTIVE"] = "ACTIVE";
  JobStatus2["BLOCKED"] = "BLOCKED";
  JobStatus2["EXPIRED"] = "EXPIRED";
  JobStatus2["PENDING"] = "PENDING";
  JobStatus2["PENDING_ACCOUNT_APPROVAL"] = "PENDING_ACCOUNT_APPROVAL";
  JobStatus2["SUSPENDED"] = "SUSPENDED";
  return JobStatus2;
})(JobStatus || {});
var JobStatusFilter = /* @__PURE__ */ ((JobStatusFilter2) => {
  JobStatusFilter2["ACTIVE"] = "ACTIVE";
  JobStatusFilter2["BLOCKED"] = "BLOCKED";
  JobStatusFilter2["EXPIRED"] = "EXPIRED";
  JobStatusFilter2["PENDING_ACCOUNT_APPROVAL"] = "PENDING_ACCOUNT_APPROVAL";
  JobStatusFilter2["SUSPENDED"] = "SUSPENDED";
  return JobStatusFilter2;
})(JobStatusFilter || {});
var LocationContext = /* @__PURE__ */ ((LocationContext2) => {
  LocationContext2["JOB_POSTING"] = "JOB_POSTING";
  LocationContext2["TALENT_SEARCH"] = "TALENT_SEARCH";
  return LocationContext2;
})(LocationContext || {});
var LocationDisplayFormat = /* @__PURE__ */ ((LocationDisplayFormat2) => {
  LocationDisplayFormat2["LONG"] = "LONG";
  LocationDisplayFormat2["SHORT"] = "SHORT";
  return LocationDisplayFormat2;
})(LocationDisplayFormat || {});
var PayPerPlacementNonEligibleResponseReason = /* @__PURE__ */ ((PayPerPlacementNonEligibleResponseReason2) => {
  PayPerPlacementNonEligibleResponseReason2["DISABLED_MARKET"] = "DISABLED_MARKET";
  PayPerPlacementNonEligibleResponseReason2["JOB_HIRER_COUNTRY_MISMATCH"] = "JOB_HIRER_COUNTRY_MISMATCH";
  PayPerPlacementNonEligibleResponseReason2["NON_ELIGIBLE_API_RESPONSE"] = "NON_ELIGIBLE_API_RESPONSE";
  PayPerPlacementNonEligibleResponseReason2["NON_ELIGIBLE_HIRER_ACCOUNT"] = "NON_ELIGIBLE_HIRER_ACCOUNT";
  PayPerPlacementNonEligibleResponseReason2["NON_ELIGIBLE_ORIGIN"] = "NON_ELIGIBLE_ORIGIN";
  PayPerPlacementNonEligibleResponseReason2["NOT_LOW_PERFORMANCE_AD"] = "NOT_LOW_PERFORMANCE_AD";
  PayPerPlacementNonEligibleResponseReason2["OVERRIDE_RESPONSE"] = "OVERRIDE_RESPONSE";
  return PayPerPlacementNonEligibleResponseReason2;
})(PayPerPlacementNonEligibleResponseReason || {});
var PayPerPlacementProduct = /* @__PURE__ */ ((PayPerPlacementProduct2) => {
  PayPerPlacementProduct2["RECRUITER_NETWORK"] = "RECRUITER_NETWORK";
  PayPerPlacementProduct2["SMART_HIRE"] = "SMART_HIRE";
  return PayPerPlacementProduct2;
})(PayPerPlacementProduct || {});
var Payment2c2pInquiryStatus = /* @__PURE__ */ ((Payment2c2pInquiryStatus2) => {
  Payment2c2pInquiryStatus2["cancelled"] = "cancelled";
  Payment2c2pInquiryStatus2["pending"] = "pending";
  Payment2c2pInquiryStatus2["processing"] = "processing";
  Payment2c2pInquiryStatus2["succeeded"] = "succeeded";
  return Payment2c2pInquiryStatus2;
})(Payment2c2pInquiryStatus || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["CONTRACT"] = "CONTRACT";
  PaymentMethod2["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethod2["INVOICE"] = "INVOICE";
  return PaymentMethod2;
})(PaymentMethod || {});
var PaymentMethodType2C2P = /* @__PURE__ */ ((PaymentMethodType2C2P2) => {
  PaymentMethodType2C2P2["BNPL"] = "BNPL";
  PaymentMethodType2C2P2["DPAY"] = "DPAY";
  PaymentMethodType2C2P2["QR"] = "QR";
  PaymentMethodType2C2P2["WEBPAY"] = "WEBPAY";
  return PaymentMethodType2C2P2;
})(PaymentMethodType2C2P || {});
var Permission = /* @__PURE__ */ ((Permission2) => {
  Permission2["createJobs"] = "createJobs";
  Permission2["manageBrand"] = "manageBrand";
  Permission2["manageUsers"] = "manageUsers";
  Permission2["payInvoices"] = "payInvoices";
  Permission2["viewInvoiceHistory"] = "viewInvoiceHistory";
  Permission2["viewManagerReports"] = "viewManagerReports";
  return Permission2;
})(Permission || {});
var PostChannel = /* @__PURE__ */ ((PostChannel2) => {
  PostChannel2["DIRECT"] = "DIRECT";
  PostChannel2["IMPORT"] = "IMPORT";
  PostChannel2["INDIRECT"] = "INDIRECT";
  return PostChannel2;
})(PostChannel || {});
var PostType = /* @__PURE__ */ ((PostType2) => {
  PostType2["DIRECT"] = "DIRECT";
  PostType2["IMPORT"] = "IMPORT";
  PostType2["INDIRECT"] = "INDIRECT";
  PostType2["PAID_AGGREGATION"] = "PAID_AGGREGATION";
  return PostType2;
})(PostType || {});
var PriceVisibility = /* @__PURE__ */ ((PriceVisibility2) => {
  PriceVisibility2["HIDE_PRICE"] = "HIDE_PRICE";
  PriceVisibility2["SHOW_DISCOUNTED_PRICE"] = "SHOW_DISCOUNTED_PRICE";
  PriceVisibility2["SHOW_RETAIL_PRICE"] = "SHOW_RETAIL_PRICE";
  return PriceVisibility2;
})(PriceVisibility || {});
var PricingModel = /* @__PURE__ */ ((PricingModel2) => {
  PricingModel2["FIXED"] = "FIXED";
  PricingModel2["HORIZON"] = "HORIZON";
  return PricingModel2;
})(PricingModel || {});
var PrivacyTypes = /* @__PURE__ */ ((PrivacyTypes2) => {
  PrivacyTypes2["limited"] = "limited";
  PrivacyTypes2["standard"] = "standard";
  return PrivacyTypes2;
})(PrivacyTypes || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["AD_BUDGET"] = "AD_BUDGET";
  ProductType2["CATALOGUE_PRODUCT"] = "CATALOGUE_PRODUCT";
  ProductType2["JOB_AD"] = "JOB_AD";
  ProductType2["JOB_AD_EDIT"] = "JOB_AD_EDIT";
  ProductType2["JOB_AD_EXTEND"] = "JOB_AD_EXTEND";
  ProductType2["JOB_AD_UPGRADE"] = "JOB_AD_UPGRADE";
  return ProductType2;
})(ProductType || {});
var ProductTypeInput = /* @__PURE__ */ ((ProductTypeInput2) => {
  ProductTypeInput2["AD_BUDGET"] = "AD_BUDGET";
  ProductTypeInput2["CATALOGUE_PRODUCT"] = "CATALOGUE_PRODUCT";
  ProductTypeInput2["JOB_AD"] = "JOB_AD";
  ProductTypeInput2["JOB_AD_EDIT"] = "JOB_AD_EDIT";
  ProductTypeInput2["JOB_AD_EXTEND"] = "JOB_AD_EXTEND";
  return ProductTypeInput2;
})(ProductTypeInput || {});
var ProfileSource = /* @__PURE__ */ ((ProfileSource2) => {
  ProfileSource2["combined"] = "combined";
  ProfileSource2["seek"] = "seek";
  return ProfileSource2;
})(ProfileSource || {});
var ProfileTypes = /* @__PURE__ */ ((ProfileTypes2) => {
  ProfileTypes2["combined"] = "combined";
  ProfileTypes2["partner"] = "partner";
  ProfileTypes2["seek"] = "seek";
  ProfileTypes2["shared"] = "shared";
  return ProfileTypes2;
})(ProfileTypes || {});
var PublishJobAdProductCode = /* @__PURE__ */ ((PublishJobAdProductCode2) => {
  PublishJobAdProductCode2["AUSKGHRB"] = "AUSKGHRB";
  PublishJobAdProductCode2["CONCIERGE"] = "CONCIERGE";
  return PublishJobAdProductCode2;
})(PublishJobAdProductCode || {});
var PurchaseContext = /* @__PURE__ */ ((PurchaseContext2) => {
  PurchaseContext2["DIRECT_AD_PRODUCT_EDIT"] = "DIRECT_AD_PRODUCT_EDIT";
  PurchaseContext2["DIRECT_AD_PRODUCT_UPGRADE_EDIT"] = "DIRECT_AD_PRODUCT_UPGRADE_EDIT";
  return PurchaseContext2;
})(PurchaseContext || {});
var QuestionnaireFilterOperator = /* @__PURE__ */ ((QuestionnaireFilterOperator2) => {
  QuestionnaireFilterOperator2["AND"] = "AND";
  QuestionnaireFilterOperator2["OR"] = "OR";
  return QuestionnaireFilterOperator2;
})(QuestionnaireFilterOperator || {});
var QuestionnaireQuestionCategory = /* @__PURE__ */ ((QuestionnaireQuestionCategory2) => {
  QuestionnaireQuestionCategory2["SALARY"] = "SALARY";
  return QuestionnaireQuestionCategory2;
})(QuestionnaireQuestionCategory || {});
var RecommendationType = /* @__PURE__ */ ((RecommendationType2) => {
  RecommendationType2["BRANDED_AD"] = "BRANDED_AD";
  RecommendationType2["GRANULAR_LOCATION"] = "GRANULAR_LOCATION";
  RecommendationType2["LOW_APPLY"] = "LOW_APPLY";
  RecommendationType2["LOW_CLICK"] = "LOW_CLICK";
  RecommendationType2["LOW_SALARY"] = "LOW_SALARY";
  RecommendationType2["REVEAL_SALARY"] = "REVEAL_SALARY";
  RecommendationType2["ROLE_REQUIREMENTS"] = "ROLE_REQUIREMENTS";
  RecommendationType2["TALENT_SEARCH"] = "TALENT_SEARCH";
  return RecommendationType2;
})(RecommendationType || {});
var RelationshipStatus = /* @__PURE__ */ ((RelationshipStatus2) => {
  RelationshipStatus2["pending"] = "pending";
  RelationshipStatus2["rejected"] = "rejected";
  return RelationshipStatus2;
})(RelationshipStatus || {});
var ResponseErrorReason = /* @__PURE__ */ ((ResponseErrorReason2) => {
  ResponseErrorReason2["BAD_INPUT"] = "BAD_INPUT";
  ResponseErrorReason2["FORBIDDEN"] = "FORBIDDEN";
  ResponseErrorReason2["NOT_FOUND"] = "NOT_FOUND";
  ResponseErrorReason2["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
  return ResponseErrorReason2;
})(ResponseErrorReason || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["ADMINISTRATOR"] = "ADMINISTRATOR";
  Role2["USER"] = "USER";
  return Role2;
})(Role || {});
var SalaryFrequency = /* @__PURE__ */ ((SalaryFrequency2) => {
  SalaryFrequency2["ANNUAL"] = "ANNUAL";
  SalaryFrequency2["HOURLY"] = "HOURLY";
  SalaryFrequency2["MONTHLY"] = "MONTHLY";
  return SalaryFrequency2;
})(SalaryFrequency || {});
var SalaryType = /* @__PURE__ */ ((SalaryType2) => {
  SalaryType2["ANNUAL_COMMISSION"] = "ANNUAL_COMMISSION";
  SalaryType2["ANNUAL_PACKAGE"] = "ANNUAL_PACKAGE";
  SalaryType2["COMMISSION_ONLY"] = "COMMISSION_ONLY";
  SalaryType2["HOURLY_RATE"] = "HOURLY_RATE";
  SalaryType2["MONTHLY"] = "MONTHLY";
  return SalaryType2;
})(SalaryType || {});
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var StripePaymentMethod = /* @__PURE__ */ ((StripePaymentMethod2) => {
  StripePaymentMethod2["card"] = "card";
  StripePaymentMethod2["fpx"] = "fpx";
  StripePaymentMethod2["id_bank_transfer"] = "id_bank_transfer";
  StripePaymentMethod2["paynow"] = "paynow";
  StripePaymentMethod2["promptpay"] = "promptpay";
  return StripePaymentMethod2;
})(StripePaymentMethod || {});
var TalentSearchAccess = /* @__PURE__ */ ((TalentSearchAccess2) => {
  TalentSearchAccess2["DISABLED"] = "DISABLED";
  TalentSearchAccess2["PREMIUM"] = "PREMIUM";
  TalentSearchAccess2["STANDARD"] = "STANDARD";
  TalentSearchAccess2["SYSTEM_DOWN"] = "SYSTEM_DOWN";
  return TalentSearchAccess2;
})(TalentSearchAccess || {});
var TalentSearchAccountsOrderByDirection = /* @__PURE__ */ ((TalentSearchAccountsOrderByDirection2) => {
  TalentSearchAccountsOrderByDirection2["asc"] = "asc";
  TalentSearchAccountsOrderByDirection2["desc"] = "desc";
  return TalentSearchAccountsOrderByDirection2;
})(TalentSearchAccountsOrderByDirection || {});
var TalentSearchAccountsOrderByField = /* @__PURE__ */ ((TalentSearchAccountsOrderByField2) => {
  TalentSearchAccountsOrderByField2["advertiserId"] = "advertiserId";
  TalentSearchAccountsOrderByField2["advertiserName"] = "advertiserName";
  return TalentSearchAccountsOrderByField2;
})(TalentSearchAccountsOrderByField || {});
var TalentSearchClaim = /* @__PURE__ */ ((TalentSearchClaim2) => {
  TalentSearchClaim2["CONNECTED_TALENT_SEARCH"] = "CONNECTED_TALENT_SEARCH";
  TalentSearchClaim2["PREMIUM_TALENT_SEARCH"] = "PREMIUM_TALENT_SEARCH";
  TalentSearchClaim2["STANDARD_TALENT_SEARCH"] = "STANDARD_TALENT_SEARCH";
  return TalentSearchClaim2;
})(TalentSearchClaim || {});
var TalentSearchConnectionStatus = /* @__PURE__ */ ((TalentSearchConnectionStatus2) => {
  TalentSearchConnectionStatus2["pending"] = "pending";
  TalentSearchConnectionStatus2["redeemed"] = "redeemed";
  TalentSearchConnectionStatus2["rejected"] = "rejected";
  return TalentSearchConnectionStatus2;
})(TalentSearchConnectionStatus || {});
var TalentSearchConnectionType = /* @__PURE__ */ ((TalentSearchConnectionType2) => {
  TalentSearchConnectionType2["ATS_MSG"] = "ATS_MSG";
  TalentSearchConnectionType2["ITA"] = "ITA";
  TalentSearchConnectionType2["JOB"] = "JOB";
  TalentSearchConnectionType2["JSP"] = "JSP";
  TalentSearchConnectionType2["MSG"] = "MSG";
  TalentSearchConnectionType2["PROFILE_EXPORT_ATS"] = "PROFILE_EXPORT_ATS";
  TalentSearchConnectionType2["UNKNOWN"] = "UNKNOWN";
  return TalentSearchConnectionType2;
})(TalentSearchConnectionType || {});
var TalentSearchContractType = /* @__PURE__ */ ((TalentSearchContractType2) => {
  TalentSearchContractType2["CONNECTED_TALENT_SEARCH"] = "CONNECTED_TALENT_SEARCH";
  TalentSearchContractType2["PREMIUM_TALENT_SEARCH"] = "PREMIUM_TALENT_SEARCH";
  TalentSearchContractType2["PREMIUM_TALENT_SEARCH_TRIAL"] = "PREMIUM_TALENT_SEARCH_TRIAL";
  return TalentSearchContractType2;
})(TalentSearchContractType || {});
var TalentSearchJobsOrderByDirection = /* @__PURE__ */ ((TalentSearchJobsOrderByDirection2) => {
  TalentSearchJobsOrderByDirection2["asc"] = "asc";
  TalentSearchJobsOrderByDirection2["desc"] = "desc";
  return TalentSearchJobsOrderByDirection2;
})(TalentSearchJobsOrderByDirection || {});
var TalentSearchJobsOrderByField = /* @__PURE__ */ ((TalentSearchJobsOrderByField2) => {
  TalentSearchJobsOrderByField2["listed"] = "listed";
  return TalentSearchJobsOrderByField2;
})(TalentSearchJobsOrderByField || {});
var TalentSearchMetadataCulture = /* @__PURE__ */ ((TalentSearchMetadataCulture2) => {
  TalentSearchMetadataCulture2["au"] = "au";
  TalentSearchMetadataCulture2["nz"] = "nz";
  return TalentSearchMetadataCulture2;
})(TalentSearchMetadataCulture || {});
var TalentSearchQuerySalaryType = /* @__PURE__ */ ((TalentSearchQuerySalaryType2) => {
  TalentSearchQuerySalaryType2["ANNUAL"] = "ANNUAL";
  TalentSearchQuerySalaryType2["HOURLY_RATE"] = "HOURLY_RATE";
  TalentSearchQuerySalaryType2["MONTHLY"] = "MONTHLY";
  return TalentSearchQuerySalaryType2;
})(TalentSearchQuerySalaryType || {});
var TalentSearchQuerySortBy = /* @__PURE__ */ ((TalentSearchQuerySortBy2) => {
  TalentSearchQuerySortBy2["CREATED_DATE"] = "CREATED_DATE";
  TalentSearchQuerySortBy2["FRESHNESS"] = "FRESHNESS";
  TalentSearchQuerySortBy2["MODIFIED_DATE"] = "MODIFIED_DATE";
  TalentSearchQuerySortBy2["RELEVANCE"] = "RELEVANCE";
  return TalentSearchQuerySortBy2;
})(TalentSearchQuerySortBy || {});
var TalentSearchSendJobStatus = /* @__PURE__ */ ((TalentSearchSendJobStatus2) => {
  TalentSearchSendJobStatus2["ALL_JOBS_SENT"] = "ALL_JOBS_SENT";
  TalentSearchSendJobStatus2["HAS_AVAILABLE_JOBS"] = "HAS_AVAILABLE_JOBS";
  TalentSearchSendJobStatus2["NO_ACTIVE_JOBS"] = "NO_ACTIVE_JOBS";
  return TalentSearchSendJobStatus2;
})(TalentSearchSendJobStatus || {});
var TaxCode = /* @__PURE__ */ ((TaxCode2) => {
  TaxCode2["GST"] = "GST";
  TaxCode2["PPN"] = "PPN";
  TaxCode2["SST"] = "SST";
  TaxCode2["VAT"] = "VAT";
  return TaxCode2;
})(TaxCode || {});
var TipsToImproveAdsType = /* @__PURE__ */ ((TipsToImproveAdsType2) => {
  TipsToImproveAdsType2["ADD_QUESTIONS"] = "ADD_QUESTIONS";
  TipsToImproveAdsType2["ADD_SPECIFIC_LOCATION"] = "ADD_SPECIFIC_LOCATION";
  TipsToImproveAdsType2["MAXIMISE_BRANDING"] = "MAXIMISE_BRANDING";
  TipsToImproveAdsType2["REVEAL_SALARY"] = "REVEAL_SALARY";
  TipsToImproveAdsType2["REVIEW_AD_DETAILS"] = "REVIEW_AD_DETAILS";
  TipsToImproveAdsType2["REVIEW_AD_SUMMARY"] = "REVIEW_AD_SUMMARY";
  return TipsToImproveAdsType2;
})(TipsToImproveAdsType || {});
var UpgradePathType = /* @__PURE__ */ ((UpgradePathType2) => {
  UpgradePathType2["UpgradeOnly"] = "UpgradeOnly";
  return UpgradePathType2;
})(UpgradePathType || {});
var UserIntentType = /* @__PURE__ */ ((UserIntentType2) => {
  UserIntentType2["PREVIEW"] = "PREVIEW";
  UserIntentType2["PURCHASE"] = "PURCHASE";
  return UserIntentType2;
})(UserIntentType || {});
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["ACTIVE"] = "ACTIVE";
  UserStatus2["DEACTIVATED"] = "DEACTIVATED";
  UserStatus2["FRAUDULENT"] = "FRAUDULENT";
  UserStatus2["PENDING"] = "PENDING";
  UserStatus2["SUSPENDED"] = "SUSPENDED";
  UserStatus2["UNVERIFIED"] = "UNVERIFIED";
  return UserStatus2;
})(UserStatus || {});
var UsersParamsFilter = /* @__PURE__ */ ((UsersParamsFilter2) => {
  UsersParamsFilter2["ACTIVE"] = "ACTIVE";
  UsersParamsFilter2["DEACTIVATED"] = "DEACTIVATED";
  UsersParamsFilter2["PENDING"] = "PENDING";
  UsersParamsFilter2["UNVERIFIED"] = "UNVERIFIED";
  return UsersParamsFilter2;
})(UsersParamsFilter || {});
var UsersParamsInclude = /* @__PURE__ */ ((UsersParamsInclude2) => {
  UsersParamsInclude2["ACCESS_DETAILS"] = "ACCESS_DETAILS";
  return UsersParamsInclude2;
})(UsersParamsInclude || {});
var WorkArrangement = /* @__PURE__ */ ((WorkArrangement2) => {
  WorkArrangement2["HYBRID"] = "HYBRID";
  WorkArrangement2["ONSITE"] = "ONSITE";
  WorkArrangement2["REMOTE"] = "REMOTE";
  return WorkArrangement2;
})(WorkArrangement || {});
var WorkType = /* @__PURE__ */ ((WorkType2) => {
  WorkType2["CASUAL"] = "CASUAL";
  WorkType2["CONTRACT_TEMP"] = "CONTRACT_TEMP";
  WorkType2["FULLTIME"] = "FULLTIME";
  WorkType2["PARTTIME"] = "PARTTIME";
  return WorkType2;
})(WorkType || {});
var YourCandidateChannel = /* @__PURE__ */ ((YourCandidateChannel2) => {
  YourCandidateChannel2["NATIVE"] = "NATIVE";
  YourCandidateChannel2["UPLOADED"] = "UPLOADED";
  return YourCandidateChannel2;
})(YourCandidateChannel || {});
var YourCandidateStatus = /* @__PURE__ */ ((YourCandidateStatus2) => {
  YourCandidateStatus2["ACCEPT"] = "ACCEPT";
  YourCandidateStatus2["INTERVIEW"] = "INTERVIEW";
  YourCandidateStatus2["NEW"] = "NEW";
  YourCandidateStatus2["OFFER"] = "OFFER";
  YourCandidateStatus2["PRESCREEN"] = "PRESCREEN";
  YourCandidateStatus2["REJECTED"] = "REJECTED";
  YourCandidateStatus2["SHORTLIST"] = "SHORTLIST";
  YourCandidateStatus2["VIEWED"] = "VIEWED";
  return YourCandidateStatus2;
})(YourCandidateStatus || {});
var YourCandidatesPayloadErrorType = /* @__PURE__ */ ((YourCandidatesPayloadErrorType2) => {
  YourCandidatesPayloadErrorType2["FORBIDDEN_ERROR"] = "FORBIDDEN_ERROR";
  YourCandidatesPayloadErrorType2["INPUT_VALIDATION_ERROR"] = "INPUT_VALIDATION_ERROR";
  YourCandidatesPayloadErrorType2["NOT_FOUND"] = "NOT_FOUND";
  YourCandidatesPayloadErrorType2["UNEXPECTED_ERROR"] = "UNEXPECTED_ERROR";
  return YourCandidatesPayloadErrorType2;
})(YourCandidatesPayloadErrorType || {});
const AdBudgetProductsForUpsellDocument = gql`
    query AdBudgetProductsForUpsell($input: AdBudgetProductsForUpsellInput!) {
  adBudgetProductsForUpsell(input: $input) {
    __typename
    ... on ProductSetExpiredError {
      message
    }
    ... on ProductSetNotFoundError {
      message
    }
    ... on AdBudgetProductList {
      items {
        id
        name
        __typename
        price {
          __typename
          ... on Price {
            retailPrice {
              value
              currency
            }
            netPrice {
              value
              currency
            }
            tax {
              amount {
                value
                currency
              }
              code
              displayRecommendation
            }
          }
        }
        adPostingFrequency
        purchasableProducts {
          ... on PurchasableProductsList {
            products
          }
          ... on PurchasableProductsString {
            product
          }
        }
        features {
          __typename
          ... on DurationFeature {
            value
            unit
          }
          ... on AdTypeDiscountsFeature {
            discounts {
              adType
              discount {
                discountPercentage
                discountAmount {
                  value
                  currency
                }
              }
            }
          }
          ... on AdSpendFeature {
            allowance {
              value
              currency
            }
          }
        }
        adRange {
          minimum
          maximum
        }
        group {
          key
        }
      }
    }
  }
}
    `;
function useAdBudgetProductsForUpsellQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(AdBudgetProductsForUpsellDocument, options);
}
function useAdBudgetProductsForUpsellLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(AdBudgetProductsForUpsellDocument, options);
}
function useAdBudgetProductsForUpsellSuspenseQuery(baseOptions) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(AdBudgetProductsForUpsellDocument, options);
}
export {
  AccessRightFilter,
  AccessRightStatus,
  AccountActivationStatus,
  AdBudgetProductsForUpsellDocument,
  AdBudgetType,
  AdRatingType,
  AdRepost,
  AdTipsType,
  AdType,
  AdTypeTheme,
  AdUsageAdStatus,
  AdvertiserStatus,
  AnalyticsAdRatingConfidence,
  AnalyticsAdRatingScore,
  AnalyticsAdRatingStatus,
  AnalyticsAdType,
  AnalyticsBenchmarkScenario,
  AnalyticsInsightsRoleAdPerformanceCode,
  AnalyticsInsightsRoleAdPerformanceRecommendationType,
  AnalyticsInsightsRoleCompetitionForTalentCode,
  AnalyticsInsightsRoleCompetitionForTalentConfidence,
  AnalyticsInsightsRoleUniqueApplicantsCode,
  AnalyticsPostTypeCategory,
  AnalyticsSalaryType,
  AnalyticsTalentSearchUsageTrendsByTimeInterval,
  AnalyticsWorkType,
  ApplicationAttachmentType,
  ApplicationBucket,
  ApplicationQuestionnaireQuestionSource,
  ApplicationQuestionnaireQuestionStatus,
  ApplicationSort,
  ApplicationSource,
  ApplicationStatusFolder,
  Bank2C2P,
  BillableStatus,
  BillingStatus,
  BrandAssetTypeEnum,
  BrandOwnerType,
  BrandState,
  CacheControlScope,
  CandidateAnswerType,
  CandidateLabel,
  CartItemProductTypeInput,
  CatalogueProductPurchaseState,
  ChannelCode,
  CompanyProfileActionType,
  ContractType,
  CreditCardBrandInput,
  Currency,
  DisplayRecommendation,
  DraftJobFlowType,
  DraftJobPaymentOption,
  DraftJobProgress,
  DraftJobSalaryCurrency,
  DraftJobWritingMode,
  DraftStatus,
  DrawdownType,
  DurationUnit,
  ExpireReason,
  FiltersAdRatingType,
  Frequency,
  GuidedDetailsType,
  HirerAccountStatus,
  HirerActivityType,
  HirerGroup,
  HirerQuestionType,
  HirerType,
  HirerUserStatus,
  IntegrationPartnerTier,
  IntegrationRelationshipTypeEnum,
  InvoiceStatus,
  JobAdBookingCountryCode,
  JobAdType,
  JobPlacementPostType,
  JobSalaryCurrency,
  JobSource,
  JobStatus,
  JobStatusFilter,
  LocationContext,
  LocationDisplayFormat,
  PayPerPlacementNonEligibleResponseReason,
  PayPerPlacementProduct,
  Payment2c2pInquiryStatus,
  PaymentMethod,
  PaymentMethodType2C2P,
  Permission,
  PostChannel,
  PostType,
  PriceVisibility,
  PricingModel,
  PrivacyTypes,
  ProductType,
  ProductTypeInput,
  ProfileSource,
  ProfileTypes,
  PublishJobAdProductCode,
  PurchaseContext,
  QuestionnaireFilterOperator,
  QuestionnaireQuestionCategory,
  RecommendationType,
  RelationshipStatus,
  ResponseErrorReason,
  Role,
  SalaryFrequency,
  SalaryType,
  SortOrder,
  StripePaymentMethod,
  TalentSearchAccess,
  TalentSearchAccountsOrderByDirection,
  TalentSearchAccountsOrderByField,
  TalentSearchClaim,
  TalentSearchConnectionStatus,
  TalentSearchConnectionType,
  TalentSearchContractType,
  TalentSearchJobsOrderByDirection,
  TalentSearchJobsOrderByField,
  TalentSearchMetadataCulture,
  TalentSearchQuerySalaryType,
  TalentSearchQuerySortBy,
  TalentSearchSendJobStatus,
  TaxCode,
  TipsToImproveAdsType,
  UpgradePathType,
  UserIntentType,
  UserStatus,
  UsersParamsFilter,
  UsersParamsInclude,
  WorkArrangement,
  WorkType,
  YourCandidateChannel,
  YourCandidateStatus,
  YourCandidatesPayloadErrorType,
  useAdBudgetProductsForUpsellLazyQuery,
  useAdBudgetProductsForUpsellQuery,
  useAdBudgetProductsForUpsellSuspenseQuery
};
